
import { Component, Vue } from "vue-property-decorator";

import vNavigation from "@/components/vNavigation.vue";
import vHeader from "@/components/vHeader.vue";

import { LOGOUT_USER } from "@/store/ActionTypes";
import { UserTypes } from "@/models/User/UserTypes";

import { CustomersModule } from "../../store/modules/CustomersModule";
import { PartnersModule } from "../../store/modules/PartnersModule";
import { mapState } from "vuex";
import {AccountState} from "@/store/modules/AccountModule";

@Component({
  components: {
    vNavigation,
    vHeader,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
      accountState: (state: any) => state.AccountModule,
    }),
  },
})
class Admin extends Vue {
  navigationOpen = false;
  headerOpen = false;
  localizationState: any;
  accountState: AccountState;
  // to be accessible in the template
  UserTypes = UserTypes;

  closeMobile() {
    if (
      typeof window.orientation !== "undefined" ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    ) {
      this.closeNavigation();
    }
  }

  logout() {
    this.$store.dispatch(LOGOUT_USER);
  }

  toggleNavigation() {
    if (this.navigationOpen) {
      this.closeNavigation();
    }
    else {
      this.openNavigation();
    }
  }

  openNavigation() {
    this.navigationOpen = true;
  }

  closeNavigation() {
    this.navigationOpen = false;
  }

  toggleHeaderMenu() {
    this.headerOpen = !this.headerOpen;
  }

  get translations() {
    return this.localizationState.translations;
  }

  created() {
    // Lazy loading of Vuex modules used only on admin panel.
    this.$store.registerModule("CustomersModule", CustomersModule);
    this.$store.registerModule("PartnersModule", PartnersModule);

    // Set language of the validator (out of the box translations)
    let language: string = this.$store.getters.getUserDetails.localization;
    language = language.substring(0, 2);

    if (this.$validator.dictionary.hasLocale(language)) {
      this.$validator.localize(language);
    }
    else {
      import(`vee-validate/dist/locale/${language}`).then((locale) => {
        this.$validator.localize(language, locale);
      });
    }
  }

  mounted() {
    Vue.nextTick(() => {
      (<any>$).Pages.initSidebar();
    });
  }

  beforeDestroy() {
    // Lazy unloading of Vuex modules used only on admin panel.
    this.$store.unregisterModule("CustomersModule");
    this.$store.unregisterModule("PartnersModule");
  }
}
export default Admin;
